import { MedereEntityContactDTO } from '../../interface/MedereEntityContactDTO';
import { Button } from 'primereact/button';

export default function ContactCard({entity, btn1, btn2}:{entity:MedereEntityContactDTO,btn1:any,btn2:any}) {
    return (
    <div className='flex flex-column entityCardContainer'>
    <div className='flex flex-row justify-content-between'>
      <div className='flex flex-column'>
      <p className='flex font-medium text-xl line-height-auto'>{entity.contactname}</p>
        {entity.contact_types_string && <p className='text-600 line-height-auto font-bold'>{entity.contact_types_string}</p>}
        {entity.contactemail && <p className='text-600 line-height-auto'>{entity.contactemail}</p>}
        {/* {entity.contactphone && <p className='text-600 line-height-auto'>{entity.contactphone}</p>} */}
      </div>
      <div className='flex flex-row'>
        {btn1 && <Button className={btn1.className} icon={"pi " + btn1.icon} onClick={btn1.onClick} />}
        {btn2 && <Button className={btn2.className} icon={"pi " + btn2.icon} onClick={btn2.onClick} />}
      </div>
    </div>
  </div>
  )
}
